<template>
  <router-view />
</template>

<script setup lang="ts">
import { nextTick, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { gtm_click } from './utils/gtm-manager'
import { storeToRefs } from "pinia"
import { useGift } from './store/giftfinder'
import { parseCookies, getCookieValue } from './utils'
const giftStore = useGift()
const route = useRoute()
import { usePlausibleStore } from "./store/plausible"
const plausibleStore = usePlausibleStore()
const { tracker } = storeToRefs(plausibleStore)
const startGTM = () => {
  const isAllowed = route?.query?.gtm !== 'false' && route?.query?.gtm !== undefined
  if(isAllowed) {
    gtm_click('Start', isAllowed)
  }
}
watch(() => route.query.gtm, (newVal) => {
  startGTM()
})
watch(() => route.query.ab, (newVal) => {
  if (tracker.value && (newVal=== '0' || newVal === '1')) {
    tracker.value("a_b", { props: { start: true,  sample: `${newVal}` }})
  }
})
onMounted(() => {
  console.log('v.2.3.0')
  // const cookie = parseCookies()
  // console.log('cookie', cookie)
  // const geolocation = getCookieValue('geolocation')
  // console.log('geolocation', geolocation)
  // console.log('route.query', route.query)
  nextTick(() => {

    startGTM()
    if (tracker.value) {
      plausibleStore.setCurrentTime()
      tracker.value("service_session", { props: { mounted: true } })
    }
    giftStore.setCatalogInfo()
  })
})

</script>
<style lang="scss" scoped>
</style>
